module.exports = __webpack_public_path__ + "img/23.aeced169.jpg";